export default function CheckIfEmailUnique(source) {
  var email = source.val();
  var isValid = false;
  $.ajax({
    data: JSON.stringify(email),
    async: false,
    contentType: "application/json",
    type: "POST",
    url: "/api/account/CheckEmailIsUnique",
    beforeSend: function () { $('.registration-number .visa-loader').addClass('display-inline-block'); },
    success: function (data) {
      if (data != null) {
        isValid = data.IsSuccess;
      }
    }
  });
  return isValid;
}